export { default, type HiddenProps } from './Hidden';
